import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { Location, PathLocationStrategy, LocationStrategy } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { OpenApiFormBuilder } from './shared/open-api-form-builder.service';

import { DialogsModule } from '@progress/kendo-angular-dialog';

// Misc Imports
import { PlatformLayoutComponent } from './shared/components/platform-layout/platform-layout.component';
import { WindowToken, windowProvider } from './shared/window.service';
import 'hammerjs';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';

@NgModule({
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		CoreModule,
		DialogsModule,
		AppRoutingModule,
		// leave at bottom
		// https://angular.io/guide/router#module-import-order-matters
	],
	declarations: [AppComponent, PlatformLayoutComponent],
	providers: [
		OpenApiFormBuilder,
		Location,
		{ provide: LocationStrategy, useClass: PathLocationStrategy },
		{ provide: WindowToken, useFactory: windowProvider },
		{ provide: ICON_SETTINGS, useValue: { type: 'font' } },
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
